/**
 * DigitalRole - Role para conversão de unidades de armazenamento digital
 *
 * Implementa os 4 pilares: Convert, Cast, Validate, Format
 *
 * Suporta AMBOS os sistemas:
 * - IEC (binário): KiB, MiB, GiB, TiB (base 1024)
 * - SI (decimal): kB, MB, GB, TB (base 1000)
 *
 * @example
 * const digital = new DigitalRole();
 * digital.convert('gibibyte', 'megabyte', 1)  // 1073.741824
 * digital.cast('megabyte', '500 MB')          // 500
 * digital.validate('megabyte', 100)           // { valid: true, errors: [] }
 * digital.format('gibibyte', 1.5)             // "1.5 GiB"
 */

import { SimpleRole, type SimpleValidationConfig } from "../../contracts";
import { DIGITAL_UNITS, DIGITAL_ALIASES } from "./constants";

// =============================================================================
// DIGITAL ROLE CLASS
// =============================================================================

export class DigitalRole extends SimpleRole {
  readonly name = "digital";
  readonly base = "byte";
  readonly units = DIGITAL_UNITS;
  readonly aliases = DIGITAL_ALIASES;

  readonly validation: SimpleValidationConfig = {
    min: 0,
    minError: "Digital storage cannot be negative",
  };
}

// =============================================================================
// SINGLETON INSTANCE
// =============================================================================

/** Instância singleton da DigitalRole */
export const digitalRole = new DigitalRole();
